import { render, staticRenderFns } from "./DeleteExtraModal.vue?vue&type=template&id=b6efeab6&"
import script from "./DeleteExtraModal.vue?vue&type=script&lang=js&"
export * from "./DeleteExtraModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports